function CarOption(sizeNbr, sizeName, imageName) {
    this.sizeNbr = sizeNbr;
    this.sizeName = sizeName;
    this.imageName = imageName;
 }


module.exports = CarOption;